import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { AmountInput } from "../shared/AmountInput";
import { ParticipantSelector } from "./ParticipantSelector";
import type { Participant, CurrencyCode } from "../../types";

interface DetailsFieldsProps {
  description: string;
  amount: number;
  paidById: string;
  currency: CurrencyCode;
  participants: Participant[];
  onChangeDescription: (value: string) => void;
  onChangeAmount: (value: number) => void;
  onChangePaidBy: (value: string) => void;
}

export function DetailsFields({
  description,
  amount,
  paidById,
  currency,
  participants,
  onChangeDescription,
  onChangeAmount,
  onChangePaidBy,
}: DetailsFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="description">Descripción</Label>
        <Input
          id="description"
          value={description}
          onChange={(e) => onChangeDescription(e.target.value)}
          placeholder="Ej: Cena, Taxi, Entradas"
          autoFocus
        />
      </div>

      <AmountInput
        value={amount}
        onChange={onChangeAmount}
        currency={currency}
        label="Monto"
      />

      <div className="space-y-2">
        <Label htmlFor="paidBy">Pagado por</Label>
        <Select value={paidById} onValueChange={onChangePaidBy}>
          <SelectTrigger id="paidBy">
            <SelectValue placeholder="Seleccionar quien pagó" />
          </SelectTrigger>
          <SelectContent>
            {participants.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
}

interface ParticipantsFieldsProps {
  participants: Participant[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export function ParticipantsFields({
  participants,
  selectedIds,
  onChange,
}: ParticipantsFieldsProps) {
  return (
    <ParticipantSelector
      participants={participants}
      selectedIds={selectedIds}
      onChange={onChange}
    />
  );
}
